import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
  makeStyles,
  withStyles,
  Link,
  Typography
} from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';

import { PinIcon } from '../customIcons';

import { selectPins, addPin, removePin } from './pinsSlice';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  txt: {
    marginRight: theme.spacing(2)
  },
  txtBtn: {
    verticalAlign: 'initial'
  }
}));

const StyledToggleButton = withStyles((theme) => ({
  root: {
    background: '#ffffff',
    color: '#323232',
    '&.Mui-selected': {
      background: theme.palette.primary[50],
      color: theme.palette.primary[600]
    }
  },
}))(ToggleButton);

const PinButton = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { pins } = useSelector(selectPins);
  const isPinned = pins.some(pin => pin.itemCode === props.itemCode);

  const handlePinning = event => {
    if(isPinned) {
      const pin = pins.find(pinItem => pinItem.itemCode === props.itemCode);
      if(pin) {
        dispatch(removePin(pin.id));
      }
    } else {
      dispatch(addPin({
        itemName: props.itemName,
        itemCode: props.itemCode,
        itemType: props.itemType,
        itemOwner: props.itemOwner
      }));
    }
  };

  return (
    <div className={classes.root}>
      <Typography variant="body2" className={classes.txt} color="textSecondary">
        {isPinned ? <span>{t('pins:pageIsPinned')}. </span> : null }
        <Link className={classes.txtBtn} component="button" onClick={handlePinning} variant="inherit" underline="always">{t(isPinned ? 'pins:unpinPage' : 'pins:pinPage')}</Link>
      </Typography>
      <StyledToggleButton
        value="pin"
        aria-label={t(isPinned ? 'pins:unpinPage' : 'pins:pinPage')}
        title={t(isPinned ? 'pins:unpinPage' : 'pins:pinPage')}
        selected={isPinned}
        onChange={handlePinning}
      >
        <PinIcon />
      </StyledToggleButton>
    </div>
  );
}

PinButton.propTypes = {
  itemCode: PropTypes.string.isRequired,
  itemName: PropTypes.string,
  itemType: PropTypes.string.isRequired,
  itemOwner: PropTypes.string.isRequired
};

export default PinButton;
